import { IIndicator } from '@jumpstart/core';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import { Form, FormikProps } from 'formik';
import React from 'react';
import { formStyles } from '../styles';
import ContentField from './ContentField';
import { IValidation } from './utils';

export default function IndicatorForm(props: FormikProps<IIndicator & {index?: number;}> & {max: number; validation:IValidation}) {
  const { values, handleChange, max, validation, touched } = props;

  return (
    <Form>
      <Grid container direction="column" sx={formStyles.section}>
      <Grid container direction="row" wrap="nowrap" style={{ maxWidth: 550 }}>
        {typeof values.index === 'number' ?
          <Grid item xs={3} style={{ marginRight: 12 }}>
            <TextField
              id="index"
              name="index"
              defaultValue={values.index}
              onBlur={handleChange}
              sx={formStyles.input}
              variant="outlined"
              label="Index"
              aria-label="Edit Index"
              type="number"
              InputProps={{ inputProps: { min: 0, max: max } }}
            />
          </Grid>
          : null
        }
        <Grid item xs={typeof values.index === 'number' ? 9 : 12}>
          <ContentField
            id="name"
            name="name"
            defaultValue={values.name}
            onBlur={handleChange}
            sx={formStyles.input}
            variant="outlined"
            label="Indicator Name"
            helperText={`Indicator ID: ${values.id}`}
            InputLabelProps={{ shrink: true }}
            validation={validation}
            touched={!!touched.name}
          />
        </Grid>
      </Grid>

      <TextField
        id="secondary"
        name="secondary"
        defaultValue={values.secondary ? values.secondary : `Step ${(typeof values.index === 'number' ? values.index : 0) + 1}`}
        onBlur={handleChange}
        sx={formStyles.input}
        variant="outlined"
        label="Secondary"
        InputLabelProps={{ shrink: true }}
      />

      <ContentField
        id="description"
        name="description"
        defaultValue={values.description}
        onBlur={handleChange}
        sx={formStyles.input}
        variant="outlined"
        label="Description"
        aria-label="Description"
        multiline
        validation={validation}
        touched={!!touched.description}
      />

      <Button
        variant="contained"
        type="submit"
        color="primary"
        style={{ maxWidth: 550 }}
      >
        Save
      </Button>
      </Grid>
    </Form>
  );
}
